import AuthService from '@/service/auth.service'
import { router } from '@/router'
import axios from 'axios'

const currentUser = JSON.parse(localStorage.getItem('user'))
const myUser = currentUser ? currentUser : null

export default {
	state: {
		user: myUser,
		token: localStorage.getItem('token') || null,
	},
	getters: {
		loggedIn(state) {
			return state.token != null
		},
		isActiveAccount(state) {
			return state.user.ouser.is_active
		},
		USER(state) {
			return state.user
		},
		userId(state) {
			return state.user.id
		},
		createAllowed(state) {
			return state.user.ouser.kmg_dzo.allow_create_tmz
		},
		createReportAllowed(state) {
			return state.user.ouser.kmg_dzo.allow_create_report
		},
	},
	mutations: {
		retrieveToken(state, token) {
			state.token = token
		},
		destroyToken(state) {
			state.token = null
		},
		set_authorized(state, user) {
			// state.token = true;
			state.user = user
		},
		logout(state) {
			state.token = null
			state.initialState.loggedIn = false
		},
		activate_user(state, user) {
			state.user = user
			state.getters.loggedIn = true
		},
	},
	actions: {
		login({ commit }, formData) {
			axios
				.post('auth/login/', {
					keyId_sign: formData.keyId_sign,
					alias_sign: formData.alias_sign,
					algorithm_sign: formData.algorithm_sign,
					subjectCn_sign: formData.subjectCn_sign,
					subjectDn_sign: formData.subjectDn_sign,
					issuerCn_sign: formData.issuerCn_sign,
					issuerDn_sign: formData.issuerDn_sign,
					serialNumber_sign: formData.serialNumber_sign,
					certNotAfter_sign: formData.certNotAfter_sign,
					certNotBefore_sign: formData.certNotBefore_sign,
					authorityKeyIdentifier_sign: formData.authorityKeyIdentifier_sign,
					pem_sign: formData.pem_sign,
				})
				.then(response => {
					localStorage.setItem('token', response.data.token)
					localStorage.setItem('user', JSON.stringify(response.data.user))
					commit('retrieveToken', response.data.token)
					commit('set_authorized', response.data.user)
					router.push({
						name: 'home',
					})
				})
				.catch(error => {
					if (error.response) {
						// Server responded with a status other than 200 range
						if (error.response.status === 400) {
							alert('Ошибка в эцп, обратитесь в тех.поддержку')
							location.reload()
						}
						if (error.response.status === 404) {
							alert('Error: Page Not Found')
						}
					} else if (error.request) {
						// Request was made but no response
						console.error(error.request)
					} else {
						console.error(error.message)
					}
				})
		},
		loginWithIin(context, credentials) {
			return new Promise((resolve, reject) => {
				axios
					.post('auth/login_iin/', {
						username: credentials.username,
						password: credentials.password,
					})
					.then(response => {
						const token = response.data.token
						localStorage.setItem('token', token)
						localStorage.setItem('user', JSON.stringify(response.data.user))
						context.commit('retrieveToken', token)
						context.commit('set_authorized', response.data.user)

						resolve(response)
					})
					.catch(error => {
						if (error.response.status === 403) {
							context.dispatch('addNotification', {
								type: 'error',
								message: 'Неверный пароль',
							})
						} else if (error.response.status === 404) {
							context.dispatch('addNotification', {
								type: 'error',
								message: 'Логин не найден',
							})
						}
						reject(error)
					})
			})
		},
		destroyToken(context) {
			localStorage.removeItem('token')
			localStorage.removeItem('user')
			localStorage.removeItem('isActive')
			context.commit('destroyToken')
		},
		activateUser({ commit }, formData) {
			return AuthService.activateUser(formData)
				.then(response => {
					localStorage.setItem('user', JSON.stringify(response.data.user))
					commit('activate_user', response.data.user)
					// router.push('/home');
				})
				.catch(error => {
					console.log(error.response.data)
				})
		},
		changePassword({ commit, dispatch }, formData) {
			return AuthService.changePassword(formData)
				.then(response => {
					dispatch('addNotification', {
						type: 'success',
						message: response.data,
					})
					return response
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data.message,
					})
				})
		},
	},
}
